import { gql } from '@apollo/client';

export const LoginMutation = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      access_token
      refresh_token
    }
  }
`;

export const RefreshMutation = gql`
  mutation refresh($refreshToken: String!) {
    refresh(refresh: $refreshToken) {
      access
    }
  }
`;

export const ForgotPasswordMutation = gql`
  mutation reset_password($email: String!) {
    reset_password(email: $email) {
      response
    }
  }
`;

export const UpdateUserMutation = gql`
  mutation UpdateUserMutation(
    $userId: Int!
    $first_name: String
    $last_name: String
    $username: String
  ) {
    update_core_user(
      where: { id: { _eq: $userId } }
      _set: { first_name: $first_name, last_name: $last_name }
    ) {
      affected_rows
      returning {
        id
        username
        first_name
        last_name
      }
    }
  }
`;

export const UPDATE_ARTIST = gql`
  mutation UpdateArtistMutation($artistId: Int!, $data: artists_set_input!) {
    update_artists(where: { id: { _eq: $artistId } }, _set: $data) {
      affected_rows
    }
  }
`;

export const UPDATE_ARTWORKS = gql`
  mutation UpdateArtworkMutation($artworkIds: [Int!], $artworks: artworks_set_input!) {
    update_artworks(where: { id: { _in: $artworkIds } }, _set: $artworks) {
      affected_rows
      returning {
        id
        # artists {
        #   name
        # }
        artwork_images {
          id
          url
        }
        image_ids
        available
        title
        price
        currency
        year_of_creation
        year_end_of_creation
        material
        about_the_artwork
        dimensions
        height_cm
        width_cm
        depth_cm
        is_unique
        edition
        edition_count
        artist_proof_count
        provenance
        signature
        courtesy
        min_price
        max_price
        vat_excluded
      }
    }
  }
`;

export const UPDATE_ADMIN_ARTWORKS = gql`
  mutation UpdateArtworkMutation($artworkIds: [Int!], $artworks: artworks_set_input!) {
    update_artworks(where: { id: { _in: $artworkIds } }, _set: $artworks) {
      affected_rows
      returning {
        id
        # artists {
        #   name
        # }
        artwork_images {
          id
          url
        }
        image_ids
        available
        title
        price
        currency
        price_visible_in_app
        unofficial_price
        year_of_creation
        year_end_of_creation
        material
        about_the_artwork
        medium
        dimensions
        height_cm
        width_cm
        depth_cm
        diameter_cm
        is_unique
        edition
        edition_count
        artist_proof_count
        provenance
        signature
        courtesy
        source
        description
        visibility_status
        caliber
        internal_validated
        external_validated
        min_price
        max_price
        unofficial_currency
        unofficial_min_price
        unofficial_max_price
        vat_excluded
      }
    }
  }
`;

export const ADD_GALLERY_COLLABORATOR = gql`
  mutation AddToGalleryGuestList($data: gallery_guest_list_insert_input!) {
    insert_gallery_guest_list_one(object: $data) {
      id
      email
    }
  }
`;
export const REMOVE_GALLERY_COLLABORATOR = gql`
  mutation RemoveFromGalleryGuestList($id: uuid!) {
    delete_gallery_guest_list_by_pk(id: $id) {
      id
    }
  }
`;
export const UPDATE_GALLERY_LOGO = gql`
  mutation UpdateGalleryLogo($galleryId: Int!, $logo: String!) {
    update_galleries(where: { id: { _eq: $galleryId } }, _set: { logo: $logo }) {
      affected_rows
    }
  }
`;

export const SignUpMutation = gql`
  mutation signup(
    $first_name: String!
    $last_name: String!
    $email: String!
    $password: String!
    $phone_number: String!
    $accepted_terms_and_conditions: Boolean!
    $accepted_updates: Boolean!
  ) {
    signup(
      first_name: $first_name
      last_name: $last_name
      email: $email
      password: $password
      accepted_terms_and_conditions: $accepted_terms_and_conditions
      accepted_updates: $accepted_updates
      phone_number: $phone_number
    ) {
      id
    }
  }
`;

export const UPLOAD_ARTWORKS = gql`
  mutation IngestGallery(
    $artworks: [IngestGalleryArtworkInput!]!
    $artists: [IngestGalleryArtistInput!]!
    $gallery_id: Int
    $institution_id: Int
    $overwrite_artworks: Boolean!
    $overwrite_artists: Boolean!
    $update_artists_cv: Boolean!
    $keep_differents_sources: Boolean!
    $ignore_filters: Boolean!
  ) {
    ingest_gallery(
      input: {
        artworks: $artworks
        artists: $artists
        gallery_id: $gallery_id
        institution_id: $institution_id
        overwrite_artworks: $overwrite_artworks
        overwrite_artists: $overwrite_artists
        update_artists_cv: $update_artists_cv
        keep_differents_sources: $keep_differents_sources
        ignore_filters: $ignore_filters
      }
    )
  }
`;

export const CREATE_GALLERY_IMAGES = gql`
  mutation createGalleryImages($object: gallery_images_insert_input!) {
    insert_gallery_images_one(object: $object) {
      id
      images
    }
  }
`;

export const UPDATE_GALLERY_IMAGES = gql`
  mutation updateGalleryImages($gallery_id: Int, $institution_id: Int, $images: _text) {
    update_gallery_images(
      where: {
        _and: [{ gallery_id: { _eq: $gallery_id } }, { institution_id: { _eq: $institution_id } }]
      }
      _set: { images: $images }
    ) {
      affected_rows
      returning {
        id
        gallery_id
        images
      }
    }
  }
`;

export const BATCH_UPLOAD_IMAGES = gql`
  mutation batchUploadImages($input: [UploadImageInput!]) {
    batch_upload_images(input: $input) {
      url
    }
  }
`;

export const UPDATE_USER_BY_EMAIL = gql`
  mutation updateUserByEmail($email: String!, $galleryId: Int) {
    update_core_user(where: { email: { _eq: $email } }, _set: { gallery_id: $galleryId }) {
      affected_rows
    }
  }
`;

export const DELETE_ARTWORK = gql`
  mutation deleteArtwork($artworkId: Int!) {
    delete_artworks_by_pk(id: $artworkId) {
      id
    }
  }
`;
export const DELETE_ARTWORKS = gql`
  mutation deleteArtworks($artworkIds: [Int!]) {
    delete_artworks(where: { id: { _in: $artworkIds } }) {
      affected_rows
    }
  }
`;

export const ADD_INSTITUTION = gql`
  mutation InsertInstitution($data: institutions_insert_input!) {
    insert_institutions_one(object: $data) {
      id
    }
  }
`;

export const ADD_AWARD = gql`
  mutation InsertAward($data: awards_insert_input!) {
    insert_awards_one(object: $data) {
      id
    }
  }
`;

export const ADD_BIENNAL = gql`
  mutation InsertBiennal($data: biennals_insert_input!) {
    insert_biennals_one(object: $data) {
      id
    }
  }
`;

export const ADD_RESIDENCY = gql`
  mutation InsertResidency($data: residencies_insert_input!) {
    insert_residencies_one(object: $data) {
      id
    }
  }
`;

export const ADD_FAIR = gql`
  mutation InserFair($data: fairs_insert_input!) {
    insert_fairs_one(object: $data) {
      id
    }
  }
`;

export const ADD_SCHOOL = gql`
  mutation InsertSchool($data: schools_insert_input!) {
    insert_schools_one(object: $data) {
      id
    }
  }
`;

export const ADD_ARTIST_INSTITUTION_EXHIBITION = gql`
  mutation AddArtistInstitutionExhibition($data: artists_institution_expositions_insert_input!) {
    insert_artists_institution_expositions_one(object: $data) {
      exposition_id
    }
  }
`;

export const ADD_ARTIST_GALLERY_EXHIBITION = gql`
  mutation AddArtistGalleryExhibition($data: artists_gallery_expositions_insert_input!) {
    insert_artists_gallery_expositions_one(object: $data) {
      exposition_id
    }
  }
`;

export const ADD_ARTIST_FAIR = gql`
  mutation AddArtistFair($data: artists_fairs_insert_input!) {
    insert_artists_fairs_one(object: $data) {
      fair_id
    }
  }
`;

export const ADD_ARTIST_BIENNAL = gql`
  mutation AddArtistBiennal($data: artists_biennals_insert_input!) {
    insert_artists_biennals_one(object: $data) {
      biennal_id
    }
  }
`;

export const ADD_ARTIST_AWARD = gql`
  mutation AddArtistAward($data: artists_awards_insert_input!) {
    insert_artists_awards_one(object: $data) {
      award_id
    }
  }
`;

export const ADD_ARTIST_RESIDENCY = gql`
  mutation AddArtistAward($data: artists_residencies_insert_input!) {
    insert_artists_residencies_one(object: $data) {
      residency_id
    }
  }
`;

export const ADD_ARTIST_SCHOOL = gql`
  mutation AddArtistSchool($data: artists_schools_insert_input!) {
    insert_artists_schools_one(object: $data) {
      school_id
    }
  }
`;

export const ADD_PUBLICATION = gql`
  mutation AddPublication($data: publications_insert_input!) {
    insert_publications_one(object: $data) {
      id
    }
  }
`;

export const ADD_ARTIST_PUBLICATION = gql`
  mutation AddArtistPublication($data: artists_publications_insert_input!) {
    insert_artists_publications_one(object: $data) {
      publication_id
    }
  }
`;

export const UPDATE_ALTERNATIVE_ARTISTS_INFO = gql`
  mutation UpdateAlternativeArtistInfos($id: Int!, $data: alternative_artists_infos_set_input!) {
    update_alternative_artists_infos_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
    }
  }
`;
export const INSERT_ALTERNATIVE_ARTISTS_INFO = gql`
  mutation InsertAlternativeArtistInfos($data: alternative_artists_infos_insert_input!) {
    insert_alternative_artists_infos_one(object: $data) {
      id
    }
  }
`;

export const UPDATE_GALLERY_ONBOARDED = gql`
  mutation UpdateGalleryOnboarded($galleryId: Int!, $isOnboarded: Boolean!) {
    update_galleries_by_pk(pk_columns: { id: $galleryId }, _set: { is_onboarded: $isOnboarded }) {
      is_onboarded
    }
  }
`;

export const DELETE_ARTIST_INSTITUTION_EXHIBITION = gql`
  mutation DeleteArtistInstititionExhibition($exhibitionId: uuid!) {
    delete_artists_institution_expositions_by_pk(exposition_id: $exhibitionId) {
      exposition_id
    }
  }
`;
export const DELETE_ARTIST_GALLERY_EXHIBITION = gql`
  mutation DeleteArtistGalleryExhibition($exhibitionId: uuid!) {
    delete_artists_gallery_expositions_by_pk(exposition_id: $exhibitionId) {
      exposition_id
    }
  }
`;
export const DELETE_ARTIST_FAIR = gql`
  mutation DeleteArtistFair($fairEditionId: uuid!) {
    delete_artists_fairs_by_pk(fair_edition_id: $fairEditionId) {
      fair_edition_id
    }
  }
`;
export const DELETE_ARTIST_BIENNAL = gql`
  mutation DeleteArtistBiennal($biennalEditionId: uuid!) {
    delete_artists_biennals_by_pk(biennal_edition_id: $biennalEditionId) {
      biennal_edition_id
    }
  }
`;
export const DELETE_ARTIST_AWARD = gql`
  mutation DeleteArtistAward($awardId: Int!, $artistId: Int!) {
    delete_artists_awards_by_pk(award_id: $awardId, artist_id: $artistId) {
      artist_id
    }
  }
`;
export const DELETE_ARTIST_SCHOOL = gql`
  mutation DeleteArtistSchool($schoolId: Int!, $artistId: Int!) {
    delete_artists_schools_by_pk(artist_id: $artistId, school_id: $schoolId) {
      school_id
    }
  }
`;
export const DELETE_ARTIST_RESIDENCY = gql`
  mutation DeleteArtistResidency($residencyEditionId: uuid!) {
    delete_artists_residencies_by_pk(residency_edition_id: $residencyEditionId) {
      residency_edition_id
    }
  }
`;
export const DELETE_ARTIST_PUBLICATION = gql`
  mutation DeleteArtistPublication($publicationId: Int!, $artistId: Int!) {
    delete_artists_publications_by_pk(publication_id: $publicationId, artist_id: $artistId) {
      publication_id
    }
  }
`;

export const UPDATE_ARTIST_INSTITUTION_EXHIBITION = gql`
  mutation UpdateArtistInstititionExhibition(
    $exhibitionId: uuid!
    $data: artists_institution_expositions_set_input
  ) {
    update_artists_institution_expositions_by_pk(
      pk_columns: { exposition_id: $exhibitionId }
      _set: $data
    ) {
      exposition_id
    }
  }
`;
export const UPDATE_ARTIST_GALLERY_EXHIBITION = gql`
  mutation UpdateArtistGalleryExhibition(
    $exhibitionId: uuid!
    $data: artists_gallery_expositions_set_input
  ) {
    update_artists_gallery_expositions_by_pk(
      pk_columns: { exposition_id: $exhibitionId }
      _set: $data
    ) {
      exposition_id
    }
  }
`;

export const UPDATE_ARTIST_FAIR = gql`
  mutation UpdateArtistBiennal($fairEditionId: uuid!, $data: artists_fairs_set_input) {
    update_artists_fairs_by_pk(pk_columns: { fair_edition_id: $fairEditionId }, _set: $data) {
      fair_edition_id
    }
  }
`;
export const UPDATE_ARTIST_BIENNAL = gql`
  mutation UpdateArtistBiennal($biennalEditionId: uuid!, $data: artists_biennals_set_input) {
    update_artists_biennals_by_pk(
      pk_columns: { biennal_edition_id: $biennalEditionId }
      _set: $data
    ) {
      biennal_edition_id
    }
  }
`;
export const UPDATE_ARTIST_AWARD = gql`
  mutation UpdateArtistAward($awardId: Int!, $artistId: Int!, $data: artists_awards_set_input) {
    update_artists_awards_by_pk(
      pk_columns: { award_id: $awardId, artist_id: $artistId }
      _set: $data
    ) {
      artist_id
    }
  }
`;
export const UPDATE_ARTIST_SCHOOL = gql`
  mutation UpdateArtistSchool($schoolId: Int!, $artistId: Int!, $data: artists_schools_set_input) {
    update_artists_schools_by_pk(
      pk_columns: { artist_id: $artistId, school_id: $schoolId }
      _set: $data
    ) {
      school_id
    }
  }
`;
export const UPDATE_ARTIST_RESIDENCY = gql`
  mutation UpdateArtistResidency($residencyEditionId: uuid!, $data: artists_residencies_set_input) {
    update_artists_residencies_by_pk(
      pk_columns: { residency_edition_id: $residencyEditionId }
      _set: $data
    ) {
      residency_edition_id
    }
  }
`;

export const ADD_ARTIST_WORKING_CITY = gql`
  mutation AddArtistWorkingCity($artistId: Int!, $cityId: Int!) {
    insert_artists_working_cities_one(object: { artist_id: $artistId, city_id: $cityId }) {
      artist_id
    }
  }
`;

export const REMOVE_ARTIST_WORKING_CITY = gql`
  mutation RemoveArtistWorkingCity($artistId: Int!, $cityId: Int!) {
    delete_artists_working_cities_by_pk(artist_id: $artistId, city_id: $cityId) {
      artist_id
    }
  }
`;

export const ADD_CITY = gql`
  mutation InsertCity($data: cities_insert_input!) {
    insert_cities_one(object: $data) {
      id
    }
  }
`;

export const ADD_INSTITUTION_CITY = gql`
  mutation InsertInstitutionCity($data: institutions_cities_insert_input!) {
    insert_institutions_cities_one(object: $data) {
      city_id
    }
  }
`;
export const ADD_BIENNAL_CITY = gql`
  mutation InsertBiennalCity($data: biennals_cities_insert_input!) {
    insert_biennals_cities_one(object: $data) {
      city_id
    }
  }
`;
export const ADD_RESIDENCY_CITY = gql`
  mutation InsertResidencyCity($data: residencies_cities_insert_input!) {
    insert_residencies_cities_one(object: $data) {
      city_id
    }
  }
`;
export const ADD_FAIR_CITY = gql`
  mutation InsertFairCity($data: fairs_cities_insert_input!) {
    insert_fairs_cities_one(object: $data) {
      city_id
    }
  }
`;
export const ADD_SCHOOL_CITY = gql`
  mutation InsertSchoolCity($data: schools_cities_insert_input!) {
    insert_fairs_schools_one(object: $data) {
      city_id
    }
  }
`;

export const ADD_ARTWORK_IMAGES = gql`
  mutation InsertArtworkImages($data: [artwork_images_insert_input!]!) {
    insert_artwork_images(objects: $data) {
      affected_rows
    }
  }
`;

export const UPDATE_ARTWORK_IMAGES = gql`
  mutation UpdateArtworkImages($id: Int!, $data: artwork_images_set_input!) {
    update_artwork_images_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
    }
  }
`;

export const DELETE_ARTWORK_IMAGES = gql`
  mutation DeleteArtworkImages($id: Int!) {
    delete_artwork_images_by_pk(id: $id) {
      id
    }
  }
`;

export const UPDATE_ARTWORK_SALE = gql`
  mutation UpdateArtworkSale($id: Int!, $data: artwork_sales_set_input!) {
    update_artwork_sales_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
    }
  }
`;

export const ADD_ARTWORK_SALE = gql`
  mutation InsertArtworkSale($data: artwork_sales_insert_input!) {
    insert_artwork_sales_one(object: $data) {
      id
    }
  }
`;
